import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import useFirestore from "../../../../config/fireBaseHook";

const DivisionsDropdown = ({
  value,
  onChange,
  name = "Sinclair_Division",
  label = "Sinclair Division",
  fullWidth = true,
  margin = "normal",
  required = false,
  disabled = false,
  ...otherProps
}) => {
  const { data: divisions, loading, error } = useFirestore("Divisions");

  const handleChange = (event) => {
    if (onChange) {
      // Create a synthetic event-like object to match the expected format
      const syntheticEvent = {
        target: {
          name: name,
          value: event.target.value,
        },
      };
      onChange(syntheticEvent);
    }
  };

  // Check if current value exists in divisions
  const currentValueExists = divisions?.some((division) => {
    const divisionName =
      division.DivisionName || division.Division_Name || division.Name;
    return (
      divisionName &&
      divisionName.trim().toLowerCase() === (value || "").trim().toLowerCase()
    );
  });

  // Sort divisions by display name — only show active divisions.
  // Active is stored as boolean true/false in the Divisions collection.
  const sortedDivisions = divisions
    ? divisions
        .filter((division) => division.Active === true)
        .sort((a, b) => {
          const nameA = (
            a.DivisionName ||
            a.Division_Name ||
            a.Name ||
            a.id ||
            ""
          ).toLowerCase();
          const nameB = (
            b.DivisionName ||
            b.Division_Name ||
            b.Name ||
            b.id ||
            ""
          ).toLowerCase();
          return nameA.localeCompare(nameB);
        })
    : [];

  if (loading) {
    return (
      <FormControl fullWidth={fullWidth} margin={margin} disabled>
        <InputLabel>{label}</InputLabel>
        <Select value="" label={label} disabled {...otherProps}>
          <MenuItem value="">
            <CircularProgress size={20} />
            <span style={{ marginLeft: 8 }}>Loading...</span>
          </MenuItem>
        </Select>
      </FormControl>
    );
  }

  if (error) {
    return (
      <FormControl fullWidth={fullWidth} margin={margin} disabled>
        <InputLabel error>{label}</InputLabel>
        <Select value="" label={label} error disabled {...otherProps}>
          <MenuItem value="">
            <span style={{ color: "red" }}>Error loading options</span>
          </MenuItem>
        </Select>
      </FormControl>
    );
  }

  return (
    <FormControl
      fullWidth={fullWidth}
      margin={margin}
      required={required}
      disabled={disabled}
    >
      <InputLabel>{label}</InputLabel>
      <Select
        value={value || ""}
        onChange={handleChange}
        label={label}
        name={name}
        {...otherProps}
      >
        <MenuItem value="">
          <em>Select {label}</em>
        </MenuItem>
        {value && !currentValueExists && (
          <MenuItem
            value={value}
            style={{ fontStyle: "italic", color: "#999" }}
          >
            {value} (Current value - not in list)
          </MenuItem>
        )}
        {sortedDivisions.map((division) => (
          <MenuItem
            key={division.id}
            value={
              division.DivisionName ||
              division.Division_Name ||
              division.Name ||
              division.id
            }
          >
            {division.DivisionName ||
              division.Division_Name ||
              division.Name ||
              division.id}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default DivisionsDropdown;
